import { Suspense } from 'react'
import { Routes as ReactRouterRoutes, Route, NavigateFunction } from 'react-router-dom'
import { ErrorBoundary } from 'react-error-boundary'

import { useAnalytics, useNavigate } from '~hooks'
import { Layout } from '~components'
import Error from './Error'
import Login from './Login'
import PasswordRecovery from './PasswordRecovery'
import Register from './Register'
import Block from './Block'
import { GenericError } from '~containers'

export let navigate: NavigateFunction

function Routes() {
  useAnalytics()
  navigate = useNavigate()

  window.addEventListener('offline', () => {
    navigate('/erro/internet')
  })

  return (
    <ErrorBoundary FallbackComponent={GenericError}>
      <Suspense fallback={<span>Loading ...</span>}>
        <ReactRouterRoutes>
          <Route path="" element={<Layout />}>
            <Route path="erro/*" element={<Error />} />
            <Route path="entrar/*" element={<Login />} />
            <Route path="recuperar-senha-motorista/*" element={<PasswordRecovery />} />
            <Route path="cadastrar/*" element={<Register />} />
            <Route path="sessao/bloqueio/*" element={<Block />} />
          </Route>
        </ReactRouterRoutes>
      </Suspense>
    </ErrorBoundary>
  )
}

export default Routes
